import React, { ChangeEvent, Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { logger } from "@formant/core/common/logger";
import { Uuid } from "@formant/core/model/Uuid";
import { InputElement } from "@formant/ui/component/common/Field";

import { track } from "../../analytics";
import { deviceStore, operateStore } from "../../stores";
import { Heading2 } from "../common/Heading2";
import { Popup } from "../common/Popup";
import { Rating } from "../common/Rating";
import { StandardButton } from "../common/StandardButton";
import { TextareaField } from "../common/TextareaField";
import * as styles from "./TeleopFeedback.scss";

const maxlength = 2000;

export interface ITeleopFeedbackProps {
    visible: boolean;
    id: Uuid;
    sessionId?: Uuid;
}

@observer
export class TeleopFeedback extends Component<ITeleopFeedbackProps> {
    @observable
    public feedback: string = "";

    @observable
    private submitted: boolean = false;

    @observable
    private rating?: number;

    public render() {
        const {
            feedback,
            submitted,
            readyToSubmit,
            onChangeFeedback,
            onSubmit,
            rating,
            onClose,
        } = this;
        const { id, sessionId, visible } = this.props;

        const device = deviceStore.get(id);
        if (!device || !sessionId) {
            return false;
        }

        return (
            <Popup visible={visible} onClose={onClose}>
                <div className={styles["post-teleop"]}>
                    <Heading2>
                        You have exited teleoperation of <b>{device.name}</b>
                    </Heading2>
                    <p>Please rate your experience (1-5)</p>
                    <Rating value={rating} onRate={this.setRating} />
                    <p>
                        Add additional notes to help us understand your
                        experience
                    </p>
                    <TextareaField
                        className={styles.feedback}
                        label="Feedback"
                        value={feedback}
                        disabled={submitted}
                        onChange={onChangeFeedback}
                    />
                    <StandardButton
                        className={styles.submit}
                        primary={true}
                        large={true}
                        disabled={!readyToSubmit() || submitted}
                        onClicked={onSubmit}
                    >
                        Submit feedback
                    </StandardButton>
                </div>
            </Popup>
        );
    }

    private setRating = (rating: number) => {
        this.rating = rating;
    };

    private readyToSubmit = () => {
        return this.feedback.length > 0 || this.rating !== undefined;
    };

    private onSubmit = () => {
        const { feedback, rating, onClose } = this;
        const { sessionId } = this.props;
        logger.info("Teleop feedback", {
            sessionId,
            rating,
            feedback,
        });
        this.submitted = true;
        track("Teleop Feedback Submitted");
        onClose();
    };

    private onChangeFeedback = (event: ChangeEvent<InputElement>) => {
        if (event.currentTarget.value.length < maxlength) {
            this.feedback = event.currentTarget.value;
        }
    };

    private onClose = () => {
        operateStore.feedbackVisible = false;
    };
}
